import axiosOriginal from "axios"

export const axios = axiosOriginal.create()
